import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {PaymentProfile} from "../types.ts";
import {PaymentProfileStatusBadge} from "../profile/PaymentProfileStatusBadge.tsx";
import TableFormattedTimestamp from '../../../utils/TableFormattedTimestamp.tsx';

export const useTableColumns = (
    {
        onRecordClick,
        billingProviderId,
    }: {
        onRecordClick: (record: PaymentProfile) => void,
        billingProviderId?: string,
    },
) => {

    const conditionalColumn: DataTableColumn<PaymentProfile> = billingProviderId
        ? {
            accessor: 'customer.name',
            title: I18n.get('Customer'),
            render: (record: PaymentProfile) => (
                <Text>{record.customer?.name || 'N/A'}</Text>
            ),
        }
        : {
            accessor: 'billingProvider.name',
            title: I18n.get('Provider'),
            render: (record: PaymentProfile) => (
                <Text>{record.billingProvider?.name || 'N/A'}</Text>
            ),
        };

    const columns: DataTableColumn<PaymentProfile>[] = [
        {
            accessor: 'name',
            title: I18n.get('Payment Profile'),
            render: (record: PaymentProfile) => (
                <Text
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick(record)}
                >
                    {record.name}
                </Text>
            ),
        },
        conditionalColumn,
        {
            accessor: 'status',
            title: I18n.get('Status'),
            render: (record: PaymentProfile) => (
                <PaymentProfileStatusBadge status={record.status}/>
            ),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            render: (record: PaymentProfile) => (
                <TableFormattedTimestamp record={record} propertyName="created"/>
            ),
        },
    ];

    return {
        columns,
    };
};
